:host {
    overflow: hidden;
}

svg {
    display: block;
}

[part='ouroboros'] {
    fill: var(--color-layout-highlight);
}

[part='text'] {
    fill: var(--color-layout-contrast);
}

:host([high-contrast]) {
    & [part='ouroboros'] {
        fill: var(--color-layout-contrast);
    }
}
